import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import './NumberDialogEditor.scss';

const getMinMax = (editor, prop, props) => {
  if ((editor[prop] === undefined) || (typeof editor[prop] === 'number')) {
    return editor[prop];
  }
  return editor[prop](props);
};

const NumberDialogEditor = (props) => {
  const { value, onValueChange, editor, className, style, error } = props;
  const [inputProps] = useState(() => {
    const ip = { 'aria-label': editor.title };
    let m = getMinMax(editor, 'min', props);
    if (m !== undefined) { ip.min = m; }
    m = getMinMax(editor, 'max', props);
    if (m !== undefined) { ip.max = m; }
    return ip;
  });
  const handleInputChange = (event) => {
    if (event.target.value === '') {
      onValueChange(undefined, editor);
    } else {
      onValueChange(Number(event.target.value), editor);
    }
  };
  return (
    <TextField
      className={classnames('grb-number-dialog-editor', className)}
      value={value === undefined ? '' : value}
      label={editor.title}
      error={!!error}
      onChange={handleInputChange}
      type="number"
      style={style}
      inputProps={inputProps}
      helperText={error}
    />
  );
};

NumberDialogEditor.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  error: PropTypes.string,
  editor: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    layout: PropTypes.string,
    undefinedValue: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

NumberDialogEditor.defaultProps = {
  value: undefined,
  className: undefined,
  style: undefined,
  error: undefined,
};

export default NumberDialogEditor;
